import type { SVGProps } from 'react';

const SvgChevronLineLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height='1em'
    viewBox='0 0 24 24'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      clipRule='evenodd'
      d='M16.53 3.47a.75.75 0 0 1 0 1.06L9.06 12l7.47 7.47a.75.75 0 1 1-1.06 1.06l-8-8a.75.75 0 0 1 0-1.06l8-8a.75.75 0 0 1 1.06 0Z'
      fill='currentColor'
      fillRule='evenodd'
    />
  </svg>
);
export default SvgChevronLineLeft;
